import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { rootPath, adminPath, prManagementPath } from 'routes'
import { Breadcrumb, Menu } from 'semantic-ui-react'
import { MappingDataContainer } from './styled'
import { AdminContainer } from '../../styled'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'

import MappingOrderGlAccount from './OrderGlAccount'
import MappingWbsAsset from './WbsAsset'

const MappingData = (props) => {
  const { user, history } = props
  const [activeItem, setActiveItem] = useState('')

  React.useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    if (user) {
      if (user.isAdmin === false) {
        history.replace(rootPath)
      }
    }
  }, [user])

  const sections = [
    { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
    { key: 'PRManagement', content: 'Purchase Requisition Managements', link: true, onClick: () => history.push(prManagementPath) },
    { key: 'Mappings', content: 'Mappings', active: true },
  ]

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Purchase Requisition Managements - Mapping Data</div>
        <Breadcrumb icon='right angle' sections={sections} />
      </div>
      <MappingDataContainer>
        <Menu pointing>
          <Menu.Item
            name='order_gl'
            content='Order No <-> GL Account'
            active={activeItem === 'order_gl'}
            onClick={(e, { name }) => setActiveItem(name)}
          />
          <Menu.Item
            name='wbs_asset'
            content='WBS <-> Asset'
            active={activeItem === 'wbs_asset'}
            onClick={(e, { name }) => setActiveItem(name)}
          />
        </Menu>
        {activeItem === 'order_gl' ? <MappingOrderGlAccount /> : null}
        {activeItem === 'wbs_asset' ? <MappingWbsAsset /> : null}
      </MappingDataContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    collapseMenu: state.app.collapseSideMenu,
  })
}

const mapDispatchToProps = {
  toggleSideMenu
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() { },
    componentWillReceiveProps(nextProp) { }
  })
)

export default enhance(MappingData)